import { render } from "./CheckboxListOpenableField.vue?vue&type=template&id=9d8113b0"
import script from "./CheckboxListOpenableField.vue?vue&type=script&lang=js"
export * from "./CheckboxListOpenableField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__